module.exports = __webpack_public_path__ + "static/media/Eric.58416f4c.jpg";